<template>
  <div class="ht">
    <div v-on:click="showTooltip">
    <i class="fa fa-info-circle i-icon" ></i>
    </div>
    <span class="tooltip" v-bind:style="{ display: display }">
      {{infoText}}
      <div id="closeBox" v-on:click="closeTooltip">
        <i class="fas fa-times"></i>
      </div>
    </span>
    
  </div>
</template>

<script>
export default {
  name: "Info",
   data() {
    return {
      display: 'none'
     }
   },
  props: {
    infoText: {
      type: String,
      default: null
    }
  },
  methods: {
    showTooltip: function(){
      this.display = 'block';
    },
    closeTooltip: function(){
      this.display = 'none';
    },
  }
};
</script>


<style scoped>
.ht {
  display: inline-block;
  margin: 0.1em;
}

.i-icon{
  cursor: pointer;
  color:blue;
}

.tooltip {
  background-color: #dcdcdc;
  padding: 1em;
  color: black;
  bottom: 0;
  left: 0;
  position: absolute;
  z-index: 1000;
  border-radius: 10px;
  opacity: 0.9;
  margin: 1em;
   font-size: 70%;
  }

#closeBox {
  background: #6e6d6b;
  color: #fff;
  font-family: 'Helvetica', 'Arial', sans-serif;
  font-size: 1em;
  font-weight: bold;
  text-align: center;
  width: 15px;
  height: 15px;
  border-radius: 5px;
  top: 0.3em;
  right: 0.3em;
  position: absolute;
}
</style>
